import { render, staticRenderFns } from "./DenominationsDetail.vue?vue&type=template&id=3b3b1ab7&"
import script from "./DenominationsDetail.vue?vue&type=script&lang=ts&"
export * from "./DenominationsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports